import { makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

const useStyles = makeStyles((theme) => ({
  modalForm: {
    padding: theme.spacing(3, 3, 2, 3),
  },
  chip: {
    background: "white",
    border: `1px solid ${grey[300]}`,
    maxWidth: "230px",
  },
  section: {
    padding: theme.spacing(2, 2, 2, 3),
    borderRadius: "8px",
    border: `2px solid ${theme.palette.primary.main}`,
  },
  companyName: {
    color: "black",
    fontSize: "14px",
    lineHeight: "24px",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    maxWidth: "278px",
  },
  standName: {
    lineHeight: "24px",
    fontWeight: 500,
    color: grey[500],
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    overflow: "hidden",
    maxWidth: "152px",
  },
  chipLabel: {
    fontSize: "14px",
    color: grey[600],
  },
  chipValue: {
    textOverflow: "ellipsis",
    overflow: "hidden",
    maxWidth: "56px",
    whiteSpace: "nowrap",
    fontSize: "12px",
    fontWeight: 500,
    color: "black",
  },
  valuesPopover: {
    width: 320,
    padding: theme.spacing(1.5),
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  valuesPopoverTitle: {
    fontSize: "14px",
    fontWeight: 500,
    color: theme.palette.text.primary,
  },
  valuesPopoverFilter: {
    fontSize: "13px",
    padding: theme.spacing(0.25, 1),
    border: `1px solid ${grey[300]}`,
    borderRadius: "6px",
  },
  valuesPopoverList: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(0.75),
    maxHeight: 240,
    overflowY: "auto",
  },
  valuesPopoverItem: {
    fontSize: "12px",
    fontWeight: 500,
    lineHeight: "20px",
    padding: theme.spacing(0, 1),
    background: grey[100],
    border: `1px solid ${grey[300]}`,
    borderRadius: "4px",
    whiteSpace: "nowrap",
  },
  valuesPopoverEmpty: {
    fontSize: "13px",
    color: grey[600],
  },
  searchInput: {
    marginTop: theme.spacing(2.5),
  },
  modalSubTitle: {
    color: grey[600],
    fontSize: "14px",
    lineHeight: "150%",
  },
  searchInputBase: {
    paddingBottom: theme.spacing(1.5),
  },
  searchInputInput: {
    marginLeft: theme.spacing(1.5),
  },
  modalTitle: {
    lineHeight: "150%",
    fontWeight: 500,
    fontSize: "24px",
  },
  sectionTitle: {
    fontWeight: 500,
    color: theme.palette.primary.main,
    letterSpacing: "0.1px",
    fontSize: "16px",
  },
  accordionDetails: {
    padding: 0,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1),
  },
  assignToPackageText: {
    fontSize: "14px",
    fontWeight: 500,
    textTransform: "none",
  },
  option: {
    alignItems: "flex-start",
  },
  optionLabel: {
    paddingTop: theme.spacing(1.125),
    overflowWrap: "anywhere",
  },
  optionIcon: {
    flexShrink: 0,
    fontSize: 16,
  },
  accordionRoot: {
    boxShadow: "none",
  },
  accordionSummary: {
    padding: 0,
  },
  toggleGroup: {
    marginBottom: theme.spacing(2),
    "& .MuiToggleButton-root": {
      textTransform: "none",
      fontWeight: 500,
    },
  },
  helperText: {
    marginTop: theme.spacing(1),
  },
  disabledSection: {
    opacity: 0.5,
    pointerEvents: "none",
  },
  assignToPackageButton: {
    borderRadius: "8px",
    boxShadow: "none",
    "&:hover": {
      backgroundColor: "rgba(41, 121, 255, 0.08)",
    },
  },
  assignToPackageButtonActive: {
    backgroundColor: "rgba(41, 121, 255, 0.08)",
    border: `1px solid ${theme.palette.primary.main}`,
    color: theme.palette.primary.main,
  },
  assignToPackageButtonUnactive: {
    backgroundColor: "transparent",
    border: `1px solid ${grey[500]}`,
    color: grey[600],
  },
  modalPaper: {
    width: 640,
  },
  modalPaperConfirmation: {
    width: 480,
  },
  modalBody: {
    overflowY: "auto",
    maxHeight: "550px",
    height: "550px",
    flexWrap: "nowrap",
  },
  borderedCheckboxItem: {
    borderBottom: `1px solid ${theme.palette.divider}`,
    paddingBottom: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  sectionHeader: {
    display: "flex",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    paddingBottom: theme.spacing(1),
  },
  sectionHeaderTitle: {
    fontWeight: 600,
    fontSize: "1rem",
    color: theme.palette.text.primary,
  },
}));

export default useStyles;
